<div class="wrapper">
  <app-shared-layout-topbar
    [enableExternal]="!!isDetailsScreen"
  ></app-shared-layout-topbar>

  <div
    class="content"
    [ngClass]="{ 'no-x-padding': isDetailsScreen, 'full-width': fullWidth }"
  >
    <router-outlet></router-outlet>
  </div>

  <app-shared-layout-footer></app-shared-layout-footer>
</div>
